<div class="kendo-dropdownlist">
  <kendo-floatinglabel text={{dropdownHeaderText}} style="width: 100%">
    <kendo-dropdownlist
      class="k-floating-label-container k-empty k-dropdown {{defaultOption ? 'has-default' : ''}}"
      [value]="defaultOption ? defaultOption : null"
      [data]="options"
      textField="label"
      valueField="value"
      (selectionChange)="onSelectionChange($event)"
      [popupSettings]="{ popupClass: 'popup-class' }"
      [style]="minWidthValue"
    ></kendo-dropdownlist>
  </kendo-floatinglabel>
</div>
